/**
 * All supported countries
 * `label` is a key that can be used for translations within each app
 */
var COUNTRIES = Object.freeze({
    AW: { label: 'COUNTRY_AW', code: 'AW', callingCode: '297' },
    AF: { label: 'COUNTRY_AF', code: 'AF', callingCode: '93' },
    AO: { label: 'COUNTRY_AO', code: 'AO', callingCode: '244' },
    AI: { label: 'COUNTRY_AI', code: 'AI', callingCode: '1264' },
    AL: { label: 'COUNTRY_AL', code: 'AL', callingCode: '355' },
    AD: { label: 'COUNTRY_AD', code: 'AD', callingCode: '376' },
    AE: { label: 'COUNTRY_AE', code: 'AE', callingCode: '971' },
    AR: { label: 'COUNTRY_AR', code: 'AR', callingCode: '54' },
    AM: { label: 'COUNTRY_AM', code: 'AM', callingCode: '374' },
    AS: { label: 'COUNTRY_AS', code: 'AS', callingCode: '1684' },
    AG: { label: 'COUNTRY_AG', code: 'AG', callingCode: '1268' },
    AU: { label: 'COUNTRY_AU', code: 'AU', callingCode: '61' },
    AT: { label: 'COUNTRY_AT', code: 'AT', callingCode: '43' },
    AZ: { label: 'COUNTRY_AZ', code: 'AZ', callingCode: '994' },
    BI: { label: 'COUNTRY_BI', code: 'BI', callingCode: '257' },
    BE: { label: 'COUNTRY_BE', code: 'BE', callingCode: '32' },
    BJ: { label: 'COUNTRY_BJ', code: 'BJ', callingCode: '229' },
    BF: { label: 'COUNTRY_BF', code: 'BF', callingCode: '226' },
    BD: { label: 'COUNTRY_BD', code: 'BD', callingCode: '880' },
    BG: { label: 'COUNTRY_BG', code: 'BG', callingCode: '359' },
    BH: { label: 'COUNTRY_BH', code: 'BH', callingCode: '973' },
    BS: { label: 'COUNTRY_BS', code: 'BS', callingCode: '1242' },
    BA: { label: 'COUNTRY_BA', code: 'BA', callingCode: '387' },
    BY: { label: 'COUNTRY_BY', code: 'BY', callingCode: '375' },
    BZ: { label: 'COUNTRY_BZ', code: 'BZ', callingCode: '501' },
    BM: { label: 'COUNTRY_BM', code: 'BM', callingCode: '1441' },
    BO: { label: 'COUNTRY_BO', code: 'BO', callingCode: '591' },
    BQ: { label: 'COUNTRY_BQ', code: 'BQ', callingCode: '599' },
    BR: { label: 'COUNTRY_BR', code: 'BR', callingCode: '55' },
    BB: { label: 'COUNTRY_BB', code: 'BB', callingCode: '1246' },
    BN: { label: 'COUNTRY_BN', code: 'BN', callingCode: '673' },
    BT: { label: 'COUNTRY_BT', code: 'BT', callingCode: '975' },
    BW: { label: 'COUNTRY_BW', code: 'BW', callingCode: '267' },
    CF: { label: 'COUNTRY_CF', code: 'CF', callingCode: '236' },
    CA: { label: 'COUNTRY_CA', code: 'CA', callingCode: '1' },
    CC: { label: 'COUNTRY_CC', code: 'CC', callingCode: '61' },
    CH: { label: 'COUNTRY_CH', code: 'CH', callingCode: '41' },
    CL: { label: 'COUNTRY_CL', code: 'CL', callingCode: '56' },
    CN: { label: 'COUNTRY_CN', code: 'CN', callingCode: '86' },
    CI: { label: 'COUNTRY_CI', code: 'CI', callingCode: '225' },
    CM: { label: 'COUNTRY_CM', code: 'CM', callingCode: '237' },
    CG: { label: 'COUNTRY_CG', code: 'CG', callingCode: '242' },
    CD: { label: 'COUNTRY_CD', code: 'CD', callingCode: '243' },
    CK: { label: 'COUNTRY_CK', code: 'CK', callingCode: '682' },
    CO: { label: 'COUNTRY_CO', code: 'CO', callingCode: '57' },
    KM: { label: 'COUNTRY_KM', code: 'KM', callingCode: '269' },
    CV: { label: 'COUNTRY_CV', code: 'CV', callingCode: '238' },
    CR: { label: 'COUNTRY_CR', code: 'CR', callingCode: '506' },
    CU: { label: 'COUNTRY_CU', code: 'CU', callingCode: '53' },
    CW: { label: 'COUNTRY_CW', code: 'CW', callingCode: '599' },
    CX: { label: 'COUNTRY_CX', code: 'CX', callingCode: '61' },
    KY: { label: 'COUNTRY_KY', code: 'KY', callingCode: '1345' },
    CY: { label: 'COUNTRY_CY', code: 'CY', callingCode: '357' },
    CZ: { label: 'COUNTRY_CZ', code: 'CZ', callingCode: '420' },
    DE: { label: 'COUNTRY_DE', code: 'DE', callingCode: '49' },
    DJ: { label: 'COUNTRY_DJ', code: 'DJ', callingCode: '253' },
    DM: { label: 'COUNTRY_DM', code: 'DM', callingCode: '1767' },
    DK: { label: 'COUNTRY_DK', code: 'DK', callingCode: '45' },
    DO: { label: 'COUNTRY_DO', code: 'DO', callingCode: '1' },
    DZ: { label: 'COUNTRY_DZ', code: 'DZ', callingCode: '213' },
    EC: { label: 'COUNTRY_EC', code: 'EC', callingCode: '593' },
    EG: { label: 'COUNTRY_EG', code: 'EG', callingCode: '20' },
    ER: { label: 'COUNTRY_ER', code: 'ER', callingCode: '291' },
    EH: { label: 'COUNTRY_EH', code: 'EH', callingCode: '212' },
    ES: { label: 'COUNTRY_ES', code: 'ES', callingCode: '34' },
    EE: { label: 'COUNTRY_EE', code: 'EE', callingCode: '372' },
    ET: { label: 'COUNTRY_ET', code: 'ET', callingCode: '251' },
    FI: { label: 'COUNTRY_FI', code: 'FI', callingCode: '358' },
    FJ: { label: 'COUNTRY_FJ', code: 'FJ', callingCode: '679' },
    FK: { label: 'COUNTRY_FK', code: 'FK', callingCode: '500' },
    FR: { label: 'COUNTRY_FR', code: 'FR', callingCode: '33' },
    FO: { label: 'COUNTRY_FO', code: 'FO', callingCode: '298' },
    GA: { label: 'COUNTRY_GA', code: 'GA', callingCode: '241' },
    GB: { label: 'COUNTRY_GB', code: 'GB', callingCode: '44' },
    GE: { label: 'COUNTRY_GE', code: 'GE', callingCode: '995' },
    GG: { label: 'COUNTRY_GG', code: 'GG', callingCode: '44' },
    GH: { label: 'COUNTRY_GH', code: 'GH', callingCode: '233' },
    GI: { label: 'COUNTRY_GI', code: 'GI', callingCode: '350' },
    GN: { label: 'COUNTRY_GN', code: 'GN', callingCode: '224' },
    GP: { label: 'COUNTRY_GP', code: 'GP', callingCode: '590' },
    GM: { label: 'COUNTRY_GM', code: 'GM', callingCode: '220' },
    GW: { label: 'COUNTRY_GW', code: 'GW', callingCode: '245' },
    GQ: { label: 'COUNTRY_GQ', code: 'GQ', callingCode: '240' },
    GR: { label: 'COUNTRY_GR', code: 'GR', callingCode: '30' },
    GD: { label: 'COUNTRY_GD', code: 'GD', callingCode: '1473' },
    GL: { label: 'COUNTRY_GL', code: 'GL', callingCode: '299' },
    GT: { label: 'COUNTRY_GT', code: 'GT', callingCode: '502' },
    GF: { label: 'COUNTRY_GF', code: 'GF', callingCode: '594' },
    GU: { label: 'COUNTRY_GU', code: 'GU', callingCode: '1671' },
    GY: { label: 'COUNTRY_GY', code: 'GY', callingCode: '592' },
    HK: { label: 'COUNTRY_HK', code: 'HK', callingCode: '852' },
    HN: { label: 'COUNTRY_HN', code: 'HN', callingCode: '504' },
    HR: { label: 'COUNTRY_HR', code: 'HR', callingCode: '385' },
    HT: { label: 'COUNTRY_HT', code: 'HT', callingCode: '509' },
    HU: { label: 'COUNTRY_HU', code: 'HU', callingCode: '36' },
    ID: { label: 'COUNTRY_ID', code: 'ID', callingCode: '62' },
    IM: { label: 'COUNTRY_IM', code: 'IM', callingCode: '44' },
    IN: { label: 'COUNTRY_IN', code: 'IN', callingCode: '91' },
    IO: { label: 'COUNTRY_IO', code: 'IO', callingCode: '246' },
    IE: { label: 'COUNTRY_IE', code: 'IE', callingCode: '353' },
    IR: { label: 'COUNTRY_IR', code: 'IR', callingCode: '98' },
    IQ: { label: 'COUNTRY_IQ', code: 'IQ', callingCode: '964' },
    IS: { label: 'COUNTRY_IS', code: 'IS', callingCode: '354' },
    IL: { label: 'COUNTRY_IL', code: 'IL', callingCode: '972' },
    IT: { label: 'COUNTRY_IT', code: 'IT', callingCode: '39' },
    JM: { label: 'COUNTRY_JM', code: 'JM', callingCode: '1876' },
    JE: { label: 'COUNTRY_JE', code: 'JE', callingCode: '44' },
    JO: { label: 'COUNTRY_JO', code: 'JO', callingCode: '962' },
    JP: { label: 'COUNTRY_JP', code: 'JP', callingCode: '81' },
    KZ: { label: 'COUNTRY_KZ', code: 'KZ', callingCode: '7' },
    KE: { label: 'COUNTRY_KE', code: 'KE', callingCode: '254' },
    KG: { label: 'COUNTRY_KG', code: 'KG', callingCode: '996' },
    KH: { label: 'COUNTRY_KH', code: 'KH', callingCode: '855' },
    KI: { label: 'COUNTRY_KI', code: 'KI', callingCode: '686' },
    KN: { label: 'COUNTRY_KN', code: 'KN', callingCode: '1869' },
    KR: { label: 'COUNTRY_KR', code: 'KR', callingCode: '82' },
    XK: { label: 'COUNTRY_XK', code: 'XK', callingCode: '383' },
    KW: { label: 'COUNTRY_KW', code: 'KW', callingCode: '965' },
    LA: { label: 'COUNTRY_LA', code: 'LA', callingCode: '856' },
    LB: { label: 'COUNTRY_LB', code: 'LB', callingCode: '961' },
    LR: { label: 'COUNTRY_LR', code: 'LR', callingCode: '231' },
    LY: { label: 'COUNTRY_LY', code: 'LY', callingCode: '218' },
    LC: { label: 'COUNTRY_LC', code: 'LC', callingCode: '1758' },
    LI: { label: 'COUNTRY_LI', code: 'LI', callingCode: '423' },
    LK: { label: 'COUNTRY_LK', code: 'LK', callingCode: '94' },
    LS: { label: 'COUNTRY_LS', code: 'LS', callingCode: '266' },
    LT: { label: 'COUNTRY_LT', code: 'LT', callingCode: '370' },
    LU: { label: 'COUNTRY_LU', code: 'LU', callingCode: '352' },
    LV: { label: 'COUNTRY_LV', code: 'LV', callingCode: '371' },
    MO: { label: 'COUNTRY_MO', code: 'MO', callingCode: '853' },
    MA: { label: 'COUNTRY_MA', code: 'MA', callingCode: '212' },
    MC: { label: 'COUNTRY_MC', code: 'MC', callingCode: '377' },
    MD: { label: 'COUNTRY_MD', code: 'MD', callingCode: '373' },
    MG: { label: 'COUNTRY_MG', code: 'MG', callingCode: '261' },
    MV: { label: 'COUNTRY_MV', code: 'MV', callingCode: '960' },
    MX: { label: 'COUNTRY_MX', code: 'MX', callingCode: '52' },
    MH: { label: 'COUNTRY_MH', code: 'MH', callingCode: '692' },
    MK: { label: 'COUNTRY_MK', code: 'MK', callingCode: '389' },
    ML: { label: 'COUNTRY_ML', code: 'ML', callingCode: '223' },
    MT: { label: 'COUNTRY_MT', code: 'MT', callingCode: '356' },
    MM: { label: 'COUNTRY_MM', code: 'MM', callingCode: '95' },
    ME: { label: 'COUNTRY_ME', code: 'ME', callingCode: '382' },
    MN: { label: 'COUNTRY_MN', code: 'MN', callingCode: '976' },
    MP: { label: 'COUNTRY_MP', code: 'MP', callingCode: '1670' },
    MZ: { label: 'COUNTRY_MZ', code: 'MZ', callingCode: '258' },
    MR: { label: 'COUNTRY_MR', code: 'MR', callingCode: '222' },
    MS: { label: 'COUNTRY_MS', code: 'MS', callingCode: '1664' },
    MQ: { label: 'COUNTRY_MQ', code: 'MQ', callingCode: '596' },
    MU: { label: 'COUNTRY_MU', code: 'MU', callingCode: '230' },
    MW: { label: 'COUNTRY_MW', code: 'MW', callingCode: '265' },
    MY: { label: 'COUNTRY_MY', code: 'MY', callingCode: '60' },
    YT: { label: 'COUNTRY_YT', code: 'YT', callingCode: '262' },
    NA: { label: 'COUNTRY_NA', code: 'NA', callingCode: '264' },
    NC: { label: 'COUNTRY_NC', code: 'NC', callingCode: '687' },
    NE: { label: 'COUNTRY_NE', code: 'NE', callingCode: '227' },
    NF: { label: 'COUNTRY_NF', code: 'NF', callingCode: '672' },
    NG: { label: 'COUNTRY_NG', code: 'NG', callingCode: '234' },
    NI: { label: 'COUNTRY_NI', code: 'NI', callingCode: '505' },
    NL: { label: 'COUNTRY_NL', code: 'NL', callingCode: '31' },
    NO: { label: 'COUNTRY_NO', code: 'NO', callingCode: '47' },
    NP: { label: 'COUNTRY_NP', code: 'NP', callingCode: '977' },
    NR: { label: 'COUNTRY_NR', code: 'NR', callingCode: '674' },
    NZ: { label: 'COUNTRY_NZ', code: 'NZ', callingCode: '64' },
    OM: { label: 'COUNTRY_OM', code: 'OM', callingCode: '968' },
    PK: { label: 'COUNTRY_PK', code: 'PK', callingCode: '92' },
    PA: { label: 'COUNTRY_PA', code: 'PA', callingCode: '507' },
    PN: { label: 'COUNTRY_PN', code: 'PN', callingCode: '64' },
    PE: { label: 'COUNTRY_PE', code: 'PE', callingCode: '51' },
    PH: { label: 'COUNTRY_PH', code: 'PH', callingCode: '63' },
    PW: { label: 'COUNTRY_PW', code: 'PW', callingCode: '680' },
    PG: { label: 'COUNTRY_PG', code: 'PG', callingCode: '675' },
    PL: { label: 'COUNTRY_PL', code: 'PL', callingCode: '48' },
    PR: { label: 'COUNTRY_PR', code: 'PR', callingCode: '1' },
    KP: { label: 'COUNTRY_KP', code: 'KP', callingCode: '850' },
    PT: { label: 'COUNTRY_PT', code: 'PT', callingCode: '351' },
    PY: { label: 'COUNTRY_PY', code: 'PY', callingCode: '595' },
    PS: { label: 'COUNTRY_PS', code: 'PS', callingCode: '970' },
    PF: { label: 'COUNTRY_PF', code: 'PF', callingCode: '689' },
    QA: { label: 'COUNTRY_QA', code: 'QA', callingCode: '974' },
    RE: { label: 'COUNTRY_RE', code: 'RE', callingCode: '262' },
    RO: { label: 'COUNTRY_RO', code: 'RO', callingCode: '40' },
    RU: { label: 'COUNTRY_RU', code: 'RU', callingCode: '7' },
    RW: { label: 'COUNTRY_RW', code: 'RW', callingCode: '250' },
    SA: { label: 'COUNTRY_SA', code: 'SA', callingCode: '966' },
    SD: { label: 'COUNTRY_SD', code: 'SD', callingCode: '249' },
    SN: { label: 'COUNTRY_SN', code: 'SN', callingCode: '221' },
    SG: { label: 'COUNTRY_SG', code: 'SG', callingCode: '65' },
    SJ: { label: 'COUNTRY_SJ', code: 'SJ', callingCode: '4779' },
    SB: { label: 'COUNTRY_SB', code: 'SB', callingCode: '677' },
    SL: { label: 'COUNTRY_SL', code: 'SL', callingCode: '232' },
    SV: { label: 'COUNTRY_SV', code: 'SV', callingCode: '503' },
    SM: { label: 'COUNTRY_SM', code: 'SM', callingCode: '378' },
    SO: { label: 'COUNTRY_SO', code: 'SO', callingCode: '252' },
    PM: { label: 'COUNTRY_PM', code: 'PM', callingCode: '508' },
    RS: { label: 'COUNTRY_RS', code: 'RS', callingCode: '381' },
    ST: { label: 'COUNTRY_ST', code: 'ST', callingCode: '239' },
    SR: { label: 'COUNTRY_SR', code: 'SR', callingCode: '597' },
    SK: { label: 'COUNTRY_SK', code: 'SK', callingCode: '421' },
    SI: { label: 'COUNTRY_SI', code: 'SI', callingCode: '386' },
    SE: { label: 'COUNTRY_SE', code: 'SE', callingCode: '46' },
    SZ: { label: 'COUNTRY_SZ', code: 'SZ', callingCode: '268' },
    SX: { label: 'COUNTRY_SX', code: 'SX', callingCode: '599' },
    SS: { label: 'COUNTRY_SS', code: 'SS', callingCode: '211' },
    SC: { label: 'COUNTRY_SC', code: 'SC', callingCode: '248' },
    SY: { label: 'COUNTRY_SY', code: 'SY', callingCode: '963' },
    TC: { label: 'COUNTRY_TC', code: 'TC', callingCode: '1649' },
    TD: { label: 'COUNTRY_TD', code: 'TD', callingCode: '235' },
    TG: { label: 'COUNTRY_TG', code: 'TG', callingCode: '228' },
    TH: { label: 'COUNTRY_TH', code: 'TH', callingCode: '66' },
    TJ: { label: 'COUNTRY_TJ', code: 'TJ', callingCode: '992' },
    TK: { label: 'COUNTRY_TK', code: 'TK', callingCode: '690' },
    TM: { label: 'COUNTRY_TM', code: 'TM', callingCode: '993' },
    TL: { label: 'COUNTRY_TL', code: 'TL', callingCode: '670' },
    TO: { label: 'COUNTRY_TO', code: 'TO', callingCode: '676' },
    TT: { label: 'COUNTRY_TT', code: 'TT', callingCode: '1868' },
    TN: { label: 'COUNTRY_TN', code: 'TN', callingCode: '216' },
    TR: { label: 'COUNTRY_TR', code: 'TR', callingCode: '90' },
    TV: { label: 'COUNTRY_TV', code: 'TV', callingCode: '688' },
    TW: { label: 'COUNTRY_TW', code: 'TW', callingCode: '886' },
    TZ: { label: 'COUNTRY_TZ', code: 'TZ', callingCode: '255' },
    UG: { label: 'COUNTRY_UG', code: 'UG', callingCode: '256' },
    UA: { label: 'COUNTRY_UA', code: 'UA', callingCode: '380' },
    UY: { label: 'COUNTRY_UY', code: 'UY', callingCode: '598' },
    US: { label: 'COUNTRY_US', code: 'US', callingCode: '1' },
    UZ: { label: 'COUNTRY_UZ', code: 'UZ', callingCode: '998' },
    VA: { label: 'COUNTRY_VA', code: 'VA', callingCode: '379' },
    VC: { label: 'COUNTRY_VC', code: 'VC', callingCode: '1784' },
    VE: { label: 'COUNTRY_VE', code: 'VE', callingCode: '58' },
    VG: { label: 'COUNTRY_VG', code: 'VG', callingCode: '1284' },
    VI: { label: 'COUNTRY_VI', code: 'VI', callingCode: '1340' },
    VN: { label: 'COUNTRY_VN', code: 'VN', callingCode: '84' },
    VU: { label: 'COUNTRY_VU', code: 'VU', callingCode: '678' },
    WF: { label: 'COUNTRY_WF', code: 'WF', callingCode: '681' },
    WS: { label: 'COUNTRY_WS', code: 'WS', callingCode: '685' },
    YE: { label: 'COUNTRY_YE', code: 'YE', callingCode: '967' },
    ZA: { label: 'COUNTRY_ZA', code: 'ZA', callingCode: '27' },
    ZM: { label: 'COUNTRY_ZM', code: 'ZM', callingCode: '260' },
    ZW: { label: 'COUNTRY_ZW', code: 'ZW', callingCode: '263' }, // Zimbabwe
});
/**
 * A list of country codes protected by GDPR
 */
var GDPR_COUNTRY_CODES = [
    // EU Countries
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    // Others (UK + Channel Islands)
    'GB',
    'GG',
    'JE',
    'IM',
    // EEA Countries
    'AD',
    'IS',
    'LI',
    'NO',
    'CH',
    // Others (Outside Europe)
    'AR',
    'CA',
    'FO',
    'IL',
    'NZ',
    'UY',
    'JP',
    'KR',
];

/** Vars */
var FILENAME = 'countries-service.ts';
/**
 * Returns the country object for the selected country code
 * @param {string} countryCode - 2 letter country code
 * @returns {Object} Country details { label, code, callingCode }
 */
var getCountryDataByCode = function (countryCode) {
    var data = COUNTRIES[countryCode];
    if (!data) {
        throw new Error("[File: " + FILENAME + "] Could not get country details for the following code: " + countryCode);
    }
    return data;
};
/**
 * Returns the phone country code for the selected country in the view
 */
var getCountryPhoneByCode = function (countryCode) {
    var countryData = getCountryDataByCode(countryCode);
    return (countryData === null || countryData === void 0 ? void 0 : countryData.callingCode) || null;
};
/**
 * Sort countries by label using locale
 *
 * NB: We use `localeCompare` to ensure that letters with
 * accents aren't ignored and pushed to the end of the array
 * during sorting as `sort` only supports English characters.
 * https://www.jstips.co/en/javascript/sorting-strings-with-accented-characters/
 *
 * @param {Array} Unsorted country list with translated labels
 * NB: Sample country object within the given array: { code: "GR", label: "Grèce", callingCode: "Grèce (+30)" }
 * @param {String} Interface language code
 * @returns {Object} Sorted by the object's label key
 */
var sortByLabel = function (countryList, interfaceLang) {
    return countryList.sort(function (a, b) { return a.label.localeCompare(b.label, [interfaceLang]); });
};
/**
 * Returns if a country is GDPR protected. Defaults to `true`.
 * @param {string} countryCode
 * @returns {boolean}
 */
var isCountryGDPRProtected = function (countryCode) {
    return countryCode ? GDPR_COUNTRY_CODES.includes(countryCode) : true;
};

export { COUNTRIES, GDPR_COUNTRY_CODES, getCountryDataByCode, getCountryPhoneByCode, isCountryGDPRProtected, sortByLabel };
//# sourceMappingURL=index.esm.js.map
